import { render, staticRenderFns } from "./medicineSchoolList.vue?vue&type=template&id=15d9007b&scoped=true"
import script from "./medicineSchoolList.vue?vue&type=script&lang=js"
export * from "./medicineSchoolList.vue?vue&type=script&lang=js"
import style0 from "./medicineSchoolList.vue?vue&type=style&index=0&id=15d9007b&prod&lang=less&scoped=true"
import style1 from "./medicineSchoolList.vue?vue&type=style&index=1&id=15d9007b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9007b",
  null
  
)

export default component.exports